import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

const CategoriesQuery = gql`
  query categories {
    categories {
      id
      parentCategoryId
      title
      name
      longName
      description
      longDescription
      metaTitle
      metaDescription
      slug
      priority
      image
      banner
      bannerLink
    }
  }
`;

interface IInputProps {
  children?: any;
  search?: string;
}

interface IResponse {
  data: any;
}

@observer
class GetCategoriesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  public render() {
    const { categories }: any = this.props;
    return this.props.children({ categories });
  }
}

export default compose(
  graphql<IInputProps, Response>(CategoriesQuery, {
    name: 'categories',
    options: props => ({ variables: { search: props.search || '' }, ssr: true })
  })
)(GetCategoriesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Categories/Categories.tsx